import React, { useEffect } from 'react';
import { Section, Container, Typography, Anchor, Button } from 'components/base';
import CountryCodeCookie from 'data/lib/countryCodeCookie';
import AuthCookie from 'ecommerce/lib/authCookie';

import { Head } from '../components/layout';

const ErrorPage = props => {
  useEffect(() => {
    CountryCodeCookie.destroy();
    AuthCookie.destroy();
  }, []);

  return (
    <>
      <Head title="Internal Error" />

      <Section>
        <Container className="text-center">
          <Anchor href="/" className="logo">
            <img src="/static/img/logo-mycanvas.svg" alt="MyCanvas" />
          </Anchor>
        </Container>
      </Section>

      <Section className="mb-5">
        <Container className="text-center">
          <Typography.H2 className="section-title mb-2">
            Oh no! We’re sorry, something has gone wrong.
          </Typography.H2>
          <Typography.H4>
            We’re working to fix the issue. Try to refresh the page in a while.
          </Typography.H4>
          <Button type="primary" className="mt-2" onClick={() => window.location.reload()}>
            Refresh Now
          </Button>
        </Container>
      </Section>

      <Section type="blue" className="text-center">
        <Container className="p-5">
          <Typography.H3 className="mb-2">Want to talk to us about this maintenance?</Typography.H3>
          <Typography.P>
            <a href="mailto:help@mycanvas.com" className="text-link">
              help@mycanvas.com
            </a>{' '}
            &nbsp;{' '}
            <a
              href="https://intercom.help/mycanvas/en/"
              target="_blank"
              rel="noreferrer"
              className="text-link"
            >
              Check out our FAQ
            </a>
          </Typography.P>
        </Container>
      </Section>

      {props.body && (
        <Section>
          <Container>
            <Typography.P>Error details:</Typography.P>
            <pre>{JSON.stringify(props.body, null, 2)}</pre>
          </Container>
        </Section>
      )}
    </>
  );
};

export default ErrorPage;
